import React from 'react';
import Col from 'react-bootstrap/Col';
import { connect } from 'react-redux';
import CategoryButton from './CategoryButton';
import GuestHeader from '../header/GuestHeader';
import properties from '../../../modules/ajio-util/properties';
import NotFoundPage from '../NotFoundPage';
import Error504 from '../../common/Error504';
import Error503 from '../../common/Error503';
import { gtmPagePush, gtmExtraInfoMeta } from '../../../modules/ga/GTMdatalayer';

const imageBaseUrl = properties.getProperty('imageBaseUrl');

class HomeView extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  bgClicked() {
    this.setState({ isBGClicked: true });
    setTimeout(() => {
      this.setState({ isBGClicked: false });
    }, 300);
  }

  triggerGtmExtraInfoMeta = () => {
    const { home: pageDetails = [] } = this.props;
    const objectToString = Object.prototype.toString;

    if (objectToString.call(pageDetails) === '[object Array]' && pageDetails.length) {
      for (let i = 0; i < pageDetails.length; i++) {
        if (objectToString.call(pageDetails[i]) === '[object Object]') {
          for (const item of Object.keys(pageDetails[i])) {
            const keyValue = pageDetails[i][item];
            if (item === 'seoTitle' || item === 'seoDescription' || item === 'seoKeyword') {
              gtmExtraInfoMeta(item, keyValue);
            } else if (item === 'banner') {
              gtmExtraInfoMeta('banner', {
                imageUrl: pageDetails[i].banner.imageUrl || '',
                typeCode: pageDetails[i].typeCode || ''
              });
            } else if (item === 'nativeCategoryNavigationListDetails') {
              if (objectToString.call(keyValue) === '[object Array]' && keyValue.length) {
                const result = keyValue.reduce((acc, obj) => {
                  acc.push({
                    nativeCategoryName: obj.nativeCategoryName || '',
                    nativeCategoryPageId: obj.nativeCategoryPageId || ''
                  });
                  return acc;
                }, []);
                gtmExtraInfoMeta('nativeCategoryNavigationListDetails', result);
              }
            }
          }
        }
      }
    }
  };

  componentDidMount() {
    gtmPagePush('home page', window.pageType || '', window.__ENV__ || '');
    this.triggerGtmExtraInfoMeta();
  }

  render() {
    const { home = {}, error = {} } = this.props;
    if (error && error.errorCode == '504') {
      return <Error504 name="home" device="desktop" />;
    }
    if (error && error.errorCode == '503') {
      return <Error503 name="home" device="desktop" />;
    }
    const homeData = Object.keys(home).length === 0 ? '' : home;
    if (Object.keys(homeData).length === 0) {
      return <NotFoundPage />;
    }
    const subTextObj =
      home.filter((data = {}) => {
        if (data.content) {
          return true;
        }
        return false;
      })[0] || {};
    const { content: subtext = '' } = subTextObj;
    const bannerImageDetails =
      home.filter(data => {
        if (data.banner) {
          return true;
        }
        return false;
      })[0] || {};
    const { banner = {} } = bannerImageDetails;
    const { imageUrl = '' } = banner;
    const styles = {
      imageStyle: {
        height: '630px',
        backgroundImage: `url(${imageUrl})`,
        marginTop: '35px',
        backgroundRepeat: 'no-repeat',
        backgroundPositionX: 'center'
      }
    };
    const { isBGClicked = false } = this.state;
    return (
      <div>
        <div className="main-header header-hgt">
          <header>
            <GuestHeader />
          </header>
        </div>
        <div
          style={styles.imageStyle}
          data-ga-event-category="bannerTap"
          data-ga-event-action="DefaultCategoryBannerClicked"
          data-ga-event-label="DefaultPageBanner"
          className={isBGClicked ? 'shake-row home-page-banner' : 'home-page-banner'}
          onClick={() => {
            this.bgClicked();
          }}
        >
          <div className="div-logo">
            <Col>
              <img
                src={`${imageBaseUrl}/static/img/ajio_beige.png`}
                alt="Ajio logo"
                className="logo-home"
              />
            </Col>
          </div>

          <div className="text-home">{subtext}</div>

          <div>
            <CategoryButton className="button-categories" />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { HomeReducer = {}, httpError = {} } = state;
  const error = httpError.home;
  const { pageDetails = [] } = HomeReducer;
  return {
    home: pageDetails,
    error
  };
}

export default HomeView = connect(mapStateToProps)(HomeView);
